import { useTranslation } from 'react-i18next';
import { Card, Center, Stack, Text, Title } from '@mantine/core';
import ChangePasswordForm from '@/components/auth/ChangePasswordForm';
import { useAuth } from '@/stores/authContext';
import { ROUTES } from '@/routes/paths';

/**
 * Блокирующий экран форс-смены пароля: показывается, когда JWT несёт `password_change_required=true`
 * (вход по временному паролю — биржевая авто-регистрация, аккаунт заведён оператором/админом).
 * До установки постоянного пароля доступ к приложению закрыт.
 */
export default function ForcePasswordChange() {
  const { t } = useTranslation();
  const { loginWithTokens, logout } = useAuth();

  return (
    <Center h="100dvh" p="md">
      <Card withBorder padding="lg" maw={440} w="100%">
        <Stack gap="md">
          <Stack gap={4}>
            <Title order={3}>{t('app.forcePassword.title')}</Title>
            <Text c="gray.7" size="sm">
              {t('app.forcePassword.desc')}
            </Text>
          </Stack>
          <ChangePasswordForm
            submitLabel={t('app.forcePassword.submit')}
            onSuccess={(tokens) => {
              if (tokens) {
                loginWithTokens(tokens);
                // Новый токен уже без password_change_required — перезагрузка на /app пропустит гейт.
                window.location.assign(ROUTES.APP);
              } else {
                logout();
              }
            }}
          />
        </Stack>
      </Card>
    </Center>
  );
}
